import React from "react";
import { Smartphone, Search, MessageCircle, Zap } from "lucide-react";

const POINTS = [
  { icon: Search, title: "Google-optimised", body: "Built so that real searches in your city land directly on your page." },
  { icon: MessageCircle, title: "Lead-first design", body: "Every section pushes WhatsApp, calls, and bookings — not vanity scrolling." },
  { icon: Smartphone, title: "Mobile-first", body: "80% of patients search on phones. Pages are tuned for thumbs, not desktops." },
  { icon: Zap, title: "Fast & lightweight", body: "Loads in seconds even on 4G — Google rewards speed with rankings." },
];

export default function Solution() {
  return (
    <section id="solution" data-testid="solution-section" className="relative py-20 lg:py-28 overflow-hidden">
      <div className="absolute inset-0 gf-grid-bg opacity-40 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <p className="text-xs uppercase tracking-[0.22em] font-bold text-[var(--gf-blue)]">Our Solution</p>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.08]">
            Landing pages engineered to <span className="text-[var(--gf-blue)]">turn searches</span> into bookings.
          </h2>
          <p className="mt-5 text-lg text-[var(--gf-text-2)]">
            We don't sell "websites". We sell a single, sharp, conversion-focused page that does one thing well — get
            you more patients and customers through WhatsApp and calls.
          </p>

          <div className="mt-7 inline-flex items-center gap-3 bg-white border border-[var(--gf-border)] rounded-2xl px-5 py-4 gf-shadow-soft">
            <div className="text-3xl font-display font-extrabold text-[var(--gf-blue)]">3×</div>
            <p className="text-sm text-[var(--gf-text-2)] leading-snug">
              avg. lift in WhatsApp / call <br /> inquiries vs. a generic website
            </p>
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
          {POINTS.map((p, i) => (
            <div
              key={i}
              data-testid={`solution-card-${i}`}
              className={`bg-white rounded-2xl border border-[var(--gf-border)] p-6 hover:-translate-y-1 hover:gf-shadow-soft transition-all ${
                i === 0 ? "sm:translate-y-4" : ""
              } ${i === 3 ? "sm:translate-y-4" : ""}`}
            >
              <div className="h-11 w-11 rounded-xl bg-[var(--gf-blue-soft)] text-[var(--gf-blue)] flex items-center justify-center">
                <p.icon className="h-5 w-5" />
              </div>
              <h3 className="font-display mt-4 text-lg font-bold">{p.title}</h3>
              <p className="text-sm text-[var(--gf-text-2)] mt-2 leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
